<div *ngIf="Errors.length > 0" class="error-message">
  <div *ngFor="let errorMessage of Errors">
    <p>{{ errorMessage }}</p>
  </div>
</div>

<div *ngIf="typeOfMessage === 'object'" class="error-message">
  <div *ngIf="Errors?.detail">
    <p>Detail:{{ Errors.detail }}</p>
  </div>
  <div *ngIf="Errors?.additionalDetails">
    <p>Additional Details:</p>
    <div *ngFor="let errorMessage of Errors.additionalDetails">
      <p>{{ errorMessage }}</p>
    </div>
  </div>
  <div *ngIf="Errors.problemList != undefined">
    <p>{{ Errors.problemList[0]?.detail ? Errors.problemList[0].detail : 'Validation Error' }}</p>
  </div>
  <div *ngIf="Errors.reasons != undefined">
    <p>{{ Errors.reasons[0]?.msg ? Errors.reasons[0].msg : 'Validation Error' }}</p>
  </div>
</div>
<div *ngIf="typeOfMessage === 'string'" class="error-message">
  <p>{{ Errors }}</p>
  <p *ngIf="customMsg">Please contact your DHL support representative</p>
</div>

<div class="mt-2">
  <mat-dialog-actions align="end">
    <button mat-dialog-close class="primary-btn float-left"> {{ "global.close" | translate}}</button>
  </mat-dialog-actions>
</div>
